import { makeWholesaleStartQuantity } from './utils';

const PriceRangeDisplay = ({
  isDbProduct,
  isWholesale,
  customMOQ,
  priceRanges,
  maxVariantPrice,
  minVariantPrice,
  WholesaleInitialQuantity,
  isCalculating = false,
  productUnit = 'piece',
  askForPricingQuotation = false,
  shouldShowWeightMessage = false,
  hasZeroDimensions = false,
}) => {
  const isSingleRange = priceRanges.length === 1;

  // If Wholesale's starting quantity is 1 then make it 2.
  // This 2 initial-start-quantity is static for now, but admin will set it dynamically.
  if (!isDbProduct && priceRanges.length) {
    makeWholesaleStartQuantity(priceRanges, WholesaleInitialQuantity);
  }

  return (
    <div className="my-2 flex justify-between items-center">
      <div className="flex items-center flex-wrap price-range-gap gap-2">
        {isSingleRange && minVariantPrice != null && maxVariantPrice != null ? (
          <div className="flex flex-col items-start min-w-[80px]">
            {/* Hidden for Now */}
            <div className="flex items-center gap-2">
              <div className="flex flex-col items-start">
                <div className="text-[11px] text-gray-500 leading-none" style={{ marginBottom: '-4px' }}>
                  Min
                </div>
                <div 
                  className="text-2xl font-medium"
                  style={{ color: isDbProduct ? '#0066cc' : '#000000' }}
                >
                  {`₹${minVariantPrice.toFixed(2)}`}
                  <span className="hidden md:inline text-[11px] text-gray-600 ml-1">/ {productUnit}</span>
                </div>
              </div>
              {maxVariantPrice !== minVariantPrice && (
                <>
                  <div 
                    className="text-2xl inline-block font-medium"
                    style={{ color: isDbProduct ? '#0066cc' : '#000000' }}
                  >-</div>
                  <div className="flex flex-col items-start">
                    <div className="text-[11px] text-gray-500 leading-none" style={{ marginBottom: '-4px' }}>
                      Max
                    </div>
                    <div 
                      className="text-2xl inline-block font-medium"
                      style={{ color: isDbProduct ? '#0066cc' : '#000000' }}
                    >
                      {`₹${maxVariantPrice.toFixed(2)}`}
                      <span className="hidden md:inline text-[11px] text-gray-600 ml-1">/ {productUnit} </span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          priceRanges.map(({ price, calculatedFBP, startQuantity }, index) => {
            return (
              <div key={price} className="flex flex-col items-start min-w-[60px] md:min-w-[80px]">
                <div className="flex items-center gap-2">
                  <div 
                    className="text-lg md:text-xl font-medium"
                    style={{ color: isDbProduct ? '#0066cc' : '#000000' }}
                  >
                    {`₹${Math.round(calculatedFBP)}`}
                    <span className="hidden md:inline text-[11px] text-gray-600 ml-1">/ {productUnit}</span>
                  </div>
                </div>
                <div className="text-xs text-gray-600 tex t-center">
                  {index === priceRanges.length - 1 ? `≥ ${startQuantity} ${productUnit}` : `${startQuantity}-${priceRanges[index + 1].startQuantity - 1} ${productUnit}`}
                </div>
                {isCalculating && <div className="text-xs text-gray-600">calculating pricing...</div>}
              </div>
            );
          })
        )}
        {askForPricingQuotation && (
          <span className="text-[11px] text-red-500 leading-none mb-0.5">Pricing for this product might not be exact from source, please Ask Quotation to get better pricing.</span>
        )}
        {shouldShowWeightMessage && 
          <div className="mb-3 px-3 py-2 bg-blue-50 border border-blue-100 rounded-lg">
            <div className="flex items-start">
              <svg className="w-4 h-4 text-blue-500 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <div>
                <p className="text-[12px] text-gray-700 font-medium leading-tight">
                  Pricing for this product might not be exact from source, please Ask Quotation to get better pricing.
                </p>
              </div>
            </div>
          </div>
        }
      </div>
      {/* Hidden for now */}
      {/* <div className='mr-[-1rem]'>
            {isWholesale && customMOQ && (
              <span className="flex items-center px-2 py-0.5 rounded-tl-lg rounded-bl-lg text-xs font-medium bg-black text-white border border-black ml-auto">
                MOQ {customMOQ}
              </span>
            )}
          </div> */}
    </div>
  );
};

export default PriceRangeDisplay;
